export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-es-ES.ae7afdec.xlsx";